module.exports = __webpack_public_path__ + "static/media/screen-video-over-fpg-2.42005115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/video-screenshots/screen-video-over-fpg-2.jpg
// module id = 725
// module chunks = 0